// Stealth Angel rebuild: "Add" buttons in the cart drawer recommendations. Follows Horizon's own add-to-cart flow
// (product-form.js): announce a CartLinesUpdateEvent, post to /cart/add with the cart sections to re-render, then
// resolve the event with the new cart and sections so the drawer and cart count update in place.
import { fetchConfig } from '@theme/utilities';
import { CartLinesUpdateEvent } from '@shopify/events';

class SasQuickAdd extends HTMLElement {
  connectedCallback() {
    this.querySelector('button')?.addEventListener('click', (event) => this.#add(event.currentTarget));
  }

  async #add(button) {
    if (button.disabled) return;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    const sectionIds = [...document.querySelectorAll('cart-items-component')].map((el) => el.dataset.sectionId).filter(Boolean);
    const formData = new FormData();
    formData.append('id', button.dataset.variantId);
    formData.append('quantity', '1');
    if (sectionIds.length) formData.append('sections', sectionIds.join(','));

    const deferred = CartLinesUpdateEvent.createPromise();
    this.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'add',
        context: 'cart',
        lines: [{ merchandiseId: button.dataset.variantId, quantity: 1 }],
        promise: deferred.promise,
      })
    );

    try {
      const config = fetchConfig('javascript', { body: formData });
      const response = await (await fetch(Theme.routes.cart_add_url, { ...config, headers: { ...config.headers, Accept: 'text/html' } })).json();
      if (response.status) throw new Error(response.message || 'Add to cart failed');
      const cart = await (await fetch(`${Theme.routes.cart_url}.json`)).json();
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: { items: cart.items, source: 'sas-quick-add', itemCount: 1, sections: response.sections, didError: false },
      });
    } catch (error) {
      deferred.reject(error);
      button.disabled = false;
      button.removeAttribute('aria-busy');
      console.warn('[sas-quick-add]', error);
    }
  }
}

if (!customElements.get('sas-quick-add')) customElements.define('sas-quick-add', SasQuickAdd);
